// @ts-ignore

import * as React from 'react';

const CheckSquare = ({ bg = '#E6EEFF', fill = `#0C29D0`, ...props }: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={21} fill="none" {...props}>
    <rect width={20} height={20} y={0.435} fill={bg || '#E6EEFF'} rx={4} />
    <path
      fill={fill || '#0C29D0'}
      d="M9.073 15.018 5 10.935l1.177-1.177 2.896 2.906 5.594-5.562 1.166 1.187-6.76 6.73Z"
    />
  </svg>
);
export { CheckSquare };
